<template>
  <v-col v-if="disks">
    <v-card
        class="pa-2"
        outlined
        tile
    >
      <h2 class="subtitle-1">Disk</h2>
      <v-list two-line>
        <v-list-item v-for="(disk, volume) in disks" :key="volume">
          <v-list-item-content>
            <v-list-item-title>{{ volume }}</v-list-item-title>
            <v-list-item-subtitle>Volume</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title>{{ disk.total }} G</v-list-item-title>
            <v-list-item-subtitle>Total</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title>{{ disk.used }} G</v-list-item-title>
            <v-list-item-subtitle>Used</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "disks",
  props: {
    disks: {
      required: true,
      type: Object,
    }
  }
}
</script>
